// extracted by mini-css-extract-plugin
export default {"cardWrapper":"Thankyou_cardWrapper__KPzdS","innerCardWrapper":"Thankyou_innerCardWrapper__YzoZY","cardBody":"Thankyou_cardBody__JWJ2l"};